import { render, staticRenderFns } from "./recentMoreLiveCourse.vue?vue&type=template&id=53f9a45a&scoped=true&"
import script from "./recentMoreLiveCourse.vue?vue&type=script&lang=js&"
export * from "./recentMoreLiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./recentMoreLiveCourse.vue?vue&type=style&index=0&id=53f9a45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9a45a",
  null
  
)

export default component.exports